import { getProperty, getId } from 'customer-data-objects/model/ImmutableModel';
// @ts-expect-error JS file
import { useStoreDependency } from 'general-store';
import SubjectDependency from '../../../../flux/dependencies/SubjectDependency';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error JS file
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import EMPTY_LABEL from '../../../../constants/EmptyLabel';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Media } from 'foundations-components/transitional/components/Media';
import { MediaLeft } from 'foundations-components/transitional/components/MediaLeft';
import { MediaBody } from 'foundations-components/transitional/components/MediaBody';
import { useMemo, useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MiniCompanyHighlight = ({
  objectType,
  subjectId
}) => {
  const subject = useStoreDependency(SubjectDependency, {
    objectType,
    subjectId
  });
  const getDomainURL = useCallback(() => {
    const domain = getProperty(subject, 'domain');
    if (!domain) {
      return null;
    }
    return domain.indexOf('http') === -1 ? `http://${domain}` : String(domain);
  }, [subject]);
  const renderTitle = useMemo(() => {
    const title = getProperty(subject, 'name') || EMPTY_LABEL;
    return /*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-50",
      marginBlockEnd: "25",
      truncate: true,
      children: title
    });
  }, [subject]);
  const renderSubtitle = useMemo(() => {
    const domain = getDomainURL();
    if (!domain) {
      return null;
    }
    return /*#__PURE__*/_jsx(Link, {
      href: domain,
      external: true,
      truncate: true,
      children: getProperty(subject, 'domain')
    });
  }, [subject, getDomainURL]);
  return /*#__PURE__*/_jsx(View, {
    overflow: "hidden",
    "data-test-id": "mini-company-highlight",
    children: /*#__PURE__*/_jsxs(Media, {
      align: "center",
      spacing: "extra-small",
      children: [/*#__PURE__*/_jsx(MediaLeft, {
        children: /*#__PURE__*/_jsx(UIAvatar, {
          size: "sm",
          companyId: subject && getId(subject),
          domain: getProperty(subject, 'domain'),
          fileManagerKey: getProperty(subject, 'hs_avatar_filemanager_key')
        })
      }), /*#__PURE__*/_jsxs(MediaBody, {
        marginBlockEnd: "-100",
        children: [renderTitle, renderSubtitle]
      })]
    })
  });
};
export default MiniCompanyHighlight;